import { NavLink, Outlet } from 'react-router-dom';
import { BrandLogo } from '../components/BrandLogo';

type NavItem = { to: string; label: string };

type Props = {
  nav: NavItem[];
  roleLabel: string;
};

export function RoleShell({ nav, roleLabel }: Props) {
  return (
    <div className="app-shell">
      <header className="app-header no-print">
        <div className="app-header__inner">
          <BrandLogo />
          <div>
            <div className="muted" style={{ marginBottom: 6 }}>{roleLabel}</div>
            <nav className="nav" aria-label={`Navigasi ${roleLabel}`}>
              {nav.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.to.split('/').filter(Boolean).length === 1}>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      </header>
      <main className="app-main"><Outlet /></main>
    </div>
  );
}
